


















































































import DataTableInstallments from '@/app/shared/components/data-tables/installments.vue';
import DialogAttemptGenerate from '@/app/shared/components/dialogs/attempt-generate.vue';
import DialogGenerateLinkUpdate from '@/app/shared/components/dialogs/generate-link-update.vue';
import DialogInstallmentAllowance from '@/app/shared/components/dialogs/installment-allowance.vue';
import DialogInstallmentCancelation from '@/app/shared/components/dialogs/installment-cancelation.vue';
import DialogInstallmentCreate from '@/app/shared/components/dialogs/installment-create.vue';
import DialogInstallmentDevolution from '@/app/shared/components/dialogs/installment-devolution.vue';
import DialogInstallmentGenerate from '@/app/shared/components/dialogs/installment-generate.vue';
import DialogInstallmentPaidByOtherWay from '@/app/shared/components/dialogs/installment-paid-by-other-way.vue';
import { InstallmentModel, WebhookEventResendModel } from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Vue } from 'vue-property-decorator';
@Component({
  components: {
    DialogInstallmentAllowance,
    DialogInstallmentDevolution,
    DialogInstallmentCancelation,
    DialogInstallmentPaidByOtherWay,
    DialogInstallmentGenerate,
    DialogAttemptGenerate,
    DialogInstallmentCreate,
    DataTableInstallments,
    DialogGenerateLinkUpdate,
  },
})
export default class PanelInstallmentComponent extends Vue {
  private data = { installmentSelectedList: [] };
  private loading = false;

  private get refs() {
    return refsService;
  }
  private async created() {
    await this.refs.modules.contract.getCampaignBlock(
      this.refs.modules.contract.contract.Id
    );
  }
  private get installmentSelectedList(): InstallmentModel[] {
    this.refs.modules.contract.SET_INSTALLMENT_SELECTED_LIST(
      this.data.installmentSelectedList
    );
    return this.refs._.cloneDeep(this.data.installmentSelectedList);
  }
  private get installmentClearSelectedList(): InstallmentModel[] {
    const installments = this.refs._.cloneDeep(
      this.data.installmentSelectedList
    ) as InstallmentModel[];
    this.refs._.map(installments, (installment) => {
      if (installment.OriginalDueDate) {
        installment.OriginalDueDate = '';
      }
    });
    return installments;
  }
  private get installmentList(): InstallmentModel[] {
    return this.refs._.cloneDeep(this.refs.modules.contract.installmentList);
  }

  private get webhookEventResendList(): WebhookEventResendModel[] {
    return this.installmentSelectedList.map((installment) => {
      const model = new WebhookEventResendModel();
      model.EventType = 'installment.updated';
      model.ReferenceId = installment.Id;
      return model;
    });
  }

  private get showCreate() {
    if (
      !this.installmentSelectedList?.length &&
      this.refs.modules.contract.paymentInfo &&
      this.refs.modules.contract.paymentInfo.length > 0
    )
      return true;
    return false;
  }
  private get showAttempt() {
    if (!this.installmentClearSelectedList?.length) return false;
    const show =
      this.installmentClearSelectedList.length == 1 &&
      (this.refs._.every(
        this.installmentClearSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.Canceled.toString()
      ) ||
        this.refs._.every(
          this.installmentClearSelectedList,
          (installment) =>
            this.refs.enums.InstallmentStatus[installment.Status] ==
            this.refs.enums.InstallmentStatus.Defaulter.toString()
        ) ||
        this.refs._.every(
          this.installmentClearSelectedList,
          (installment) =>
            this.refs.enums.InstallmentStatus[installment.Status] ==
            this.refs.enums.InstallmentStatus.RefundInProgress.toString()
        ) ||
        this.refs._.every(
          this.installmentClearSelectedList,
          (installment) =>
            this.refs.enums.InstallmentStatus[installment.Status] ==
            this.refs.enums.InstallmentStatus.Refunded.toString()
        ));
    return show;
  }
  private get showLinkGeneration() {
    if (!this.installmentClearSelectedList?.length) return false;
    const show =
      this.installmentClearSelectedList.length == 1 &&
      (this.refs._.every(
        this.installmentClearSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.Generated.toString()
      ) ||
        this.refs._.every(
          this.installmentClearSelectedList,
          (installment) =>
            this.refs.enums.InstallmentStatus[installment.Status] ==
            this.refs.enums.InstallmentStatus.Defaulter.toString()
        ));
    return show;
  }
  private get showAllowance() {
    if (!this.installmentSelectedList?.length) return false;
    const show =
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.Defaulter.toString()
      ) ||
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.Canceled.toString()
      ) ||
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
            this.refs.enums.InstallmentStatus.InProgress.toString() &&
          this.refs.enums.PaymentMethod[installment.PaymentMethod!] !=
            this.refs.enums.PaymentMethod.Debit.toString()
      ) ||
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
            this.refs.enums.InstallmentStatus.Generated.toString() &&
          this.refs.enums.PaymentMethod[installment.PaymentMethod!] ==
            this.refs.enums.PaymentMethod.Debit.toString()
      );
    return show;
  }
  private get showDevolution() {
    // Para contratos "Parcelado ou SmartParcelado" apenas exibir botão de devolução quando a situação for Cancelada
    const contract = this.refs.modules.contract.contract;
    const billingMode = this.refs.enums.BillingMode[contract.BillingMode ?? -1];
    const status = this.refs.enums.ContractStatus[contract.Status ?? -1];

    if (
      (billingMode == this.refs.enums.BillingMode.Parcel.toString() ||
        billingMode == this.refs.enums.BillingMode.SmartParcel.toString()) &&
      status != this.refs.enums.ContractStatus.Canceled.toString() &&
      status != this.refs.enums.ContractStatus.Finalized.toString()
    ) {
      return false;
    }

    if (!this.installmentSelectedList?.length) return false;
    const show = this.refs._.every(
      this.installmentSelectedList,
      (installment) =>
        this.refs.enums.InstallmentStatus[installment.Status] ==
        this.refs.enums.InstallmentStatus.Paid.toString()
    );
    return show;
  }

  private get showPaidByOtherWay() {
    if (!this.installmentSelectedList?.length) return false;
    const show =
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
            this.refs.enums.InstallmentStatus.InProgress.toString() &&
          this.refs.enums.PaymentMethod[installment.PaymentMethod!] !=
            this.refs.enums.PaymentMethod.Debit.toString()
      ) ||
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.Defaulter.toString()
      ) ||
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.Generated.toString()
      ) ||
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.Accredit.toString()
      ) ||
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.ChargebackRequested.toString()
      ) ||
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.Refunded.toString()
      ) ||
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.Canceled.toString()
      ) ||
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
            this.refs.enums.InstallmentStatus.Generated.toString() &&
          this.refs.enums.PaymentMethod[installment.PaymentMethod!] ==
            this.refs.enums.PaymentMethod.Debit.toString()
      );
    return show;
  }

  private get showCanceled() {
    if (!this.installmentSelectedList?.length) return false;
    const show =
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
            this.refs.enums.InstallmentStatus.InProgress.toString() &&
          this.refs.enums.PaymentMethod[installment.PaymentMethod!] !=
            this.refs.enums.PaymentMethod.Debit.toString()
      ) ||
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.Generated.toString()
      ) ||
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.Accredit.toString()
      ) ||
      this.refs._.every(
        this.installmentSelectedList,
        (installment) =>
          this.refs.enums.InstallmentStatus[installment.Status] ==
          this.refs.enums.InstallmentStatus.PaidByOtherWay.toString()
      );
    return show;
  }

  private get showResendWebhook() {
    if (!this.installmentSelectedList?.length) return false;
    const show = this.refs._.every(
      this.installmentSelectedList,
      (installment) =>
        this.refs.enums.InstallmentStatus[installment.Status] ==
        this.refs.enums.InstallmentStatus.Paid.toString()
    );
    return show;
  }

  private async resendWebhook() {
    try {
      this.loading = true;
      const list = this.webhookEventResendList;
      await this.refs.modules.contract
        .resendWebhook({
          contractId: this.refs.modules.contract.contract.Id,
          list: this.refs._.cloneDeep(list),
        })
        .then(() => {
          this.$toast(this.$t('toasts.resend_webhook_successfully'));
        });
    } catch (error) {
      this.$toast.error(this.$t('toasts.resend_webhook_error'));
    } finally {
      this.loading = false;
    }
  }
}
